import React, { cloneElement } from "react";
import { MessageCircle, Users, Sparkles, PlayCircle } from "lucide-react";
export const HowItWorks = () => {
  return <div className="py-20 bg-white" data-id="element-837">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-838">
        <div className="text-center mb-16" data-id="element-839">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-840">
            Four Steps to Not Sucking at Outreach
          </h2>
          <p className="text-xl text-gray-600" data-id="element-841">
            It's not rocket science (we made sure of that)
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-842">
          <Step icon={<MessageCircle data-id="element-844" />} number="1" title="Chat It Out" description="Tell us what you're about. Like talking to a friend who actually gets business" data-id="element-843" />
          <Step icon={<Users data-id="element-846" />} number="2" title="Get Your People" description="We'll find the right prospects. No more spray and pray" data-id="element-845" />
          <Step icon={<Sparkles data-id="element-848" />} number="3" title="Check the Magic" description="Review personalized messages that don't make people cringe" data-id="element-847" />
          <Step icon={<PlayCircle data-id="element-850" />} number="4" title="Hit Send & Chill" description="Watch the responses roll in while you focus on what matters" data-id="element-849" />
        </div>
      </div>
    </div>;
};
const Step = ({
  icon,
  number,
  title,
  description
}) => <div className="flex flex-col items-center text-center group" data-id="element-851">
    <div className="relative" data-id="element-852">
      <div className="w-20 h-20 bg-[#d5ff00]/20 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-[#d5ff00]/30 transition-colors duration-300" data-id="element-853">
        <div className="text-[#6366f1] relative" data-id="element-854">
          {cloneElement(icon, {
          size: 32,
          className: "transform group-hover:scale-110 transition-transform duration-300"
        })}
          <div className="absolute -top-2 -right-2 w-6 h-6 bg-[#6366f1] rounded-full flex items-center justify-center text-sm text-white font-bold" data-id="element-855">
            {number}
          </div>
        </div>
      </div>
    </div>
    <h3 className="text-xl font-semibold mb-2 text-gray-900" data-id="element-856">{title}</h3>
    <p className="text-gray-600" data-id="element-857">{description}</p>
  </div>;